"use strict";

exports.erc721Abi = void 0;
const erc721Abi = exports.erc721Abi = ['function balanceOf(address owner) public view override returns (uint256) '];